module.exports = "/assets/landing-rwx/instagram/twitter.png?5Ia70Vs";